import * as React from 'react';
import { memo } from 'react';

import i18n from 'helper/i18n';

import TeaserRound from 'components/molecules/TeaserRound';
import { CoachExpertDtoType } from 'types/services/magnolia/dtos/CoachExpertDto';

export type ProgramExpertPropsType = {
	title: string;
	hideExpertLogo: boolean;
	experts: CoachExpertDtoType[];
};

const ProgramExperts = ({ title, hideExpertLogo = false, experts = [] }: ProgramExpertPropsType) => (
	<div className="m-program-expert">
		<div className="container">
			<div className="row">
				<div className="col-xs-12 col-md-9">
					<h2 className="m-program-expert__title">{title}</h2>
				</div>
			</div>
			<div className="row">
				{experts.map((expert: CoachExpertDtoType, index: number) => {
					const { category, expertLink, portrait, name, logo } = expert;

					if (!name || !portrait) {
						return null;
					}

					return (
						<div key={`${category}-${name}-${index}`} className="m-program-expert__teaser">
							<div className="col-xs-12 col-sm-4 col-md-4">
								<TeaserRound
									link={{
										...expertLink,
										title: i18n('react.impulsCoach.components.programExperts.linkOverlayTitle'),
									}}
									categoryTitle={category}
									title={name}
									image={portrait as any}
									logo={hideExpertLogo ? undefined : (logo as any)}
								/>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	</div>
);

ProgramExperts.displayName = 'ProgramExpert';

export { ProgramExperts };
export default memo(ProgramExperts);
